import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";

export type ThreadsQueryThread = NonNullable<
  ResultOf<typeof threadFieldsFragment>
>;

export const threadFieldsFragment = graphql(`
  fragment ThreadFields on Thread {
    id
    closed
    threadable_type
    threadable_id
    subscription {
      id
      read_at
      notifications_enabled
    }
    managed_by_id
    managedBy {
      id
      name
    }
    threadable {
      __typename
      ... on WorkOrder {
        id
        reference
        status
        assignments {
          id
        }
        supplier {
          name
          logo {
            ...MediaFields
          }
        }
        departureAddress {
          city
        }
        deliveryAddress {
          city
        }
      }
    }
    subscribers {
      id
      user_id
      read_at
      user {
        id
        name
        profilePicture {
          ...MediaFields
        }
      }
    }
    latestMessage {
      id
      body
      is_admin_note
      user_id
      created_at
    }
  }
`);

export const threadRecordQuery = graphql(`
  query Thread($id: ID!) {
    thread(id: $id) {
      ...ThreadFields
    }
  }
`);

export const supplierThreadQuery = graphql(`
  query SupplierThread($id: ID!) {
    thread(id: $id) {
      id
      closed
      subscription {
        id
        read_at
      }
      latestMessage {
        id
        created_at
      }
    }
  }
`);

export const threadUnreadCountQuery = graphql(`
  query ThreadUnreadCount($supplier_id: ID, $status: ThreadStatusFilter) {
    unreadThreadCount(supplier_id: $supplier_id, status: $status)
  }
`);

export const threadsInfiniteList = graphql(`
  query ThreadsInfiniteList(
    $first: Int!
    $page: Int
    $status: ThreadStatusFilter
    $threadable_type: ModelType
    $threadable_id: ID
    $supplier_id: ID
    $sort: ThreadSort
    $search: String
  ) {
    threads(
      first: $first
      page: $page
      status: $status
      threadable_type: $threadable_type
      threadable_id: $threadable_id
      supplier_id: $supplier_id
      sort: $sort
      search: $search
    ) {
      data {
        ...ThreadFields
      }
      paginatorInfo {
        ...PaginationFields
      }
    }
  }
`);
